<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="530"
        >
          <el-table-column
              prop="year"
              :show-overflow-tooltip="true"
              label="年份"
              width="100"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="field"
              :show-overflow-tooltip="true"
              label="领域"
              width="100"
          >
            <template slot-scope="scope">
              <div>
                {{scope.row.field|dictname('fl_field')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="oneLevelAgent"
              :show-overflow-tooltip="true"
              label="一级经销商编码"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.oneLevelAgent }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="oneLevelAgentName"
              :show-overflow-tooltip="true"
              label="一级经销商名称"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.oneLevelAgentName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentType"
              :show-overflow-tooltip="true"
              label="分销商类型"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentType }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="soldToCode"
              :show-overflow-tooltip="true"
              label="分销商编码"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.soldToCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="soldToName"
              :show-overflow-tooltip="true"
              label="分销商名称"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.soldToName }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        oneLevelAgent: '',
        date: new Date().getFullYear().toString()+(new Date().getMonth()+1).toString(),
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
    }
  },
  created() {
    this.query();
  },
  methods: {
    //查询table
    query() {
      this.q.month = this.$route.query.month;
      this.q.oneLevelAgent = this.$route.query.oneLevelAgent;
      this.q.year = this.$route.query.year;
      this.q.field = this.$route.query.field;
      ss.fanli.selectFxServiceNumDetailPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>
